/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import Toolbar from 'loracoms/Toolbar';
import IntlMsg from 'lorautils/intl/IntlMsg';
import GatewayLog from '../../../GatewayLog';
import styles from './styles/main.scss';


const defaultProps = {
  gateway: {},
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  gatewayId: React.PropTypes.string.isRequired,
  gateway: React.PropTypes.object.isRequired,
};

class LogView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      gateway: props.gateway,
    };
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.logview');
  }

  componentWillReceiveProps(nextProps) {
    const { gateway } = nextProps;
    if (gateway !== this.props.gateway) {
      this.setState({ gateway });
    }
  }

  renderToolbar() {
    const { gateway } = this.state;
    const breadcrumb = [{
      content: this.intlMsg.msg('breadcrumbs.gateways', 'gatewaydetail'),
      onClick: () => this.props.pushState('/gateway'),
    }, {
      content: gateway.name,
      active: true,
    }];

    return (
      <Toolbar breadcrumb={breadcrumb} />
    );
  }

  render() {
    const { gatewayId } = this.props;
    return (
      <div>
        <Grid fluid>
          <Row>
            <Col md={12}>
              {this.renderToolbar()}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <GatewayLog gatewayId={gatewayId} />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

LogView.defaultProps = defaultProps;
LogView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  gateway: state.gateway.gateway.data,
  gatewayId: ownProps.params.id,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(LogView));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/LogView/index.jsx